import { ResultFile } from '@alilc/lowcode-types';
import { createResultFile } from '../../../../../../../../utils/resultHelper';

export default function getFile(): [string[], ResultFile] {
    const file = createResultFile(
        'menu',
        'js',
        `
import {Menu} from "antd";
import Icon from "@ant-design/icons";
import {Link} from "react-router-dom";
let SubMenu = Menu.SubMenu
const compose = (f, g) => ((x,y) => f(x,g(y)));


//获取菜单项
const getMenuItem = (menuArray) => {
    let menuItemArr =[]
    menuArray.map(item => {
            if (item.to) {
                menuItemArr.push (<Menu.Item key={item.key} icon={item.icon&&<Icon component={item.icon}></Icon>}>
                    <Link to={item.to}>{item.name}</Link>
                </Menu.Item>)
            } else {
                menuItemArr.push ( <SubMenu key={item.key} icon={item.icon&&<Icon component={item.icon}></Icon>} title={item.name}>
                    {getMenuItem(item.child)}
                </SubMenu>)
            }
        }
    )
    return menuItemArr

}

export const getOpenKeys=(menuArray)=>{
    return menuArray.map(i=> i.key)
}

//获取菜单
export const getMenu = (menuArray, onSelect) => {
    return (<Menu
        onSelect={onSelect}
        mode="inline"
        defaultOpenKeys={getOpenKeys(menuArray)}
        defaultSelectedKeys={["dashboard"]}
        style={{ borderRight: 0}}
    >
        {getMenuItem(menuArray)}
    </Menu>)
}

export const flattenMenu = (arr) => {
    return arr.reduce((acc, cur) => {
        if (Array.isArray(cur.child)) {
            return acc.concat([...flattenMenu(cur.child), cur])
        } else {
            acc.push(cur)
        }
        return acc
    }, [])
}

export const getMenuPath = (keyPath, flatMenu) => {
    let array = []
    keyPath.map(key => {
        const fMenu = flatMenu.filter(menu => {
            return key == menu.key
        })
        if(fMenu.length){
            array.push(fMenu[0])
        }
    })
    return array.reverse()
}

export const fcGetMenuPath = compose(getMenuPath,flattenMenu)

    `,
    );

    return [['src', 'menu'], file];
}
